"use client";

import { useCartDetail } from "@/components/hooks/use-cart-detail";
import { useAppSelector } from "@/store/hooks";
import { isObject } from "@/lib/type-guards";
import AddToCartEmptyState from "@/components/add-to-cart/empty-state";
import CartItems from "@/components/add-to-cart/cart-items";
import SimilarProducts from "@/components/shared/similar-products";
import CTABannerSection from "@/components/shared/cta-banner-section";

interface AddToCartPageViewProps {
  products?: any[];
}

export default function AddToCartPageView({ products }: AddToCartPageViewProps) {
  useCartDetail();
  const cartDetail = useAppSelector((state) => state.cartDetail);
  const cart = cartDetail?.cart;

  const hasItems = isObject(cart) && cart.items && cart.items.length > 0;

  return (
    <>
      {hasItems ? (
        <>
          <CartItems />
          <SimilarProducts products={products} />
        </>
      ) : (
        <AddToCartEmptyState />
      )}
      <CTABannerSection />
    </>
  );
}
